import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaymentOrderDeductionDetail  {
    _originalTypeClassName = "zERP.BO.PaymentOrderDeductionDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaymentOrderDeductionDetail.translate = translateService;
}
this.Id = null;
this.Amount = null;
this.IsNewItem = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Amount:any;
IsNewItem:any;
TaxCategory:any;
NormalPaymentOrder:any;
SettlementPaymentOrder:any;
Invoice:any;
TaxTotalsType:any;
WithheldInvoiceDetail:any;
FeesInvoiceDetail:any;
OtherTaxesInvoiceDetail:any;
StampDutyInvoiceDetail:any;
DeductionsInvoiceDetail:any;
static setTaxCategory = ($this, value) => {
var oldValue = $this.TaxCategory;
$this.TaxCategory = value;
if (value != null) {
}
}
static setNormalPaymentOrder = ($this, value) => {
var oldValue = $this.NormalPaymentOrder;
$this.NormalPaymentOrder = value;
if (value != null) {
if (oldValue != null) {
Domain.PaymentOrder.removeDeductionDetails(oldValue, $this);
}
Domain.PaymentOrder.addDeductionDetails(value, $this);
}
}
static setSettlementPaymentOrder = ($this, value) => {
var oldValue = $this.SettlementPaymentOrder;
$this.SettlementPaymentOrder = value;
if (value != null) {
if (oldValue != null) {
Domain.PaymentOrder.removeSettlementDetails(oldValue, $this);
}
Domain.PaymentOrder.addSettlementDetails(value, $this);
}
}
static setInvoice = ($this, value) => {
var oldValue = $this.Invoice;
$this.Invoice = value;
if (value != null) {
}
}
static setTaxTotalsType = ($this, value) => {
var oldValue = $this.TaxTotalsType;
$this.TaxTotalsType = value;
if (value != null) {
if (oldValue != null && oldValue.PaymentOrderDeductionDetail != null) { oldValue.PaymentOrderDeductionDetail = null; }
if ($this.TaxTotalsType.PaymentOrderDeductionDetail !== $this) {
Domain.TaxTotalsType.setPaymentOrderDeductionDetail(value, $this);
}
}
}
static setWithheldInvoiceDetail = ($this, value) => {
var oldValue = $this.WithheldInvoiceDetail;
$this.WithheldInvoiceDetail = value;
if (value != null) {
if (oldValue != null && oldValue.WithheldPaymentOrderDeductionDetail != null) { oldValue.WithheldPaymentOrderDeductionDetail = null; }
if ($this.WithheldInvoiceDetail.WithheldPaymentOrderDeductionDetail !== $this) {
Domain.InvoiceRowType.setWithheldPaymentOrderDeductionDetail(value, $this);
}
}
}
static setFeesInvoiceDetail = ($this, value) => {
var oldValue = $this.FeesInvoiceDetail;
$this.FeesInvoiceDetail = value;
if (value != null) {
if (oldValue != null && oldValue.FeesPaymentOrderDeductionDetail != null) { oldValue.FeesPaymentOrderDeductionDetail = null; }
if ($this.FeesInvoiceDetail.FeesPaymentOrderDeductionDetail !== $this) {
Domain.InvoiceRowType.setFeesPaymentOrderDeductionDetail(value, $this);
}
}
}
static setOtherTaxesInvoiceDetail = ($this, value) => {
var oldValue = $this.OtherTaxesInvoiceDetail;
$this.OtherTaxesInvoiceDetail = value;
if (value != null) {
if (oldValue != null && oldValue.OtherTaxesPaymentOrderDeductionDetail != null) { oldValue.OtherTaxesPaymentOrderDeductionDetail = null; }
if ($this.OtherTaxesInvoiceDetail.OtherTaxesPaymentOrderDeductionDetail !== $this) {
Domain.InvoiceRowType.setOtherTaxesPaymentOrderDeductionDetail(value, $this);
}
}
}
static setStampDutyInvoiceDetail = ($this, value) => {
var oldValue = $this.StampDutyInvoiceDetail;
$this.StampDutyInvoiceDetail = value;
if (value != null) {
if (oldValue != null && oldValue.StampDutyPaymentOrderDeductionDetail != null) { oldValue.StampDutyPaymentOrderDeductionDetail = null; }
if ($this.StampDutyInvoiceDetail.StampDutyPaymentOrderDeductionDetail !== $this) {
Domain.InvoiceRowType.setStampDutyPaymentOrderDeductionDetail(value, $this);
}
}
}
static setDeductionsInvoiceDetail = ($this, value) => {
var oldValue = $this.DeductionsInvoiceDetail;
$this.DeductionsInvoiceDetail = value;
if (value != null) {
if (oldValue != null && oldValue.DeductionsPaymentOrderDeductionDetail != null) { oldValue.DeductionsPaymentOrderDeductionDetail = null; }
if ($this.DeductionsInvoiceDetail.DeductionsPaymentOrderDeductionDetail !== $this) {
Domain.InvoiceRowType.setDeductionsPaymentOrderDeductionDetail(value, $this);
}
}
}

static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}